"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIDRep = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var DRepType_1 = require("./DRepType.js");
;
function isIDRep(stuff) {
    return (0, obj_utils_1.isObject)(stuff) && (0, DRepType_1.isDRepType)(stuff.drepType);
}
exports.isIDRep = isIDRep;
